module.exports = __webpack_public_path__ + "img/follow-house.6d9b72c6.png";